import { styled } from '@mui/material/styles';
import { Box, Typography, TypographyProps } from '@mui/material';
import { createElement } from 'react';

const SectionTitleBase = (props: TypographyProps) =>
  createElement(Typography, { variant: 'h6', ...props });

export const SectionTitle = styled(SectionTitleBase)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '1rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.25rem',
  },
}));

export const FormButtonGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(3),
  gap: theme.spacing(2),
  flexWrap: 'wrap',
}));
